"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignOut = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SignOut = function SignOut() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.667 21.333H10c.368 0 .667.299.667.667v1.333A.667.667 0 0110 24H2.667A2.667 2.667 0 010 21.333V2.667A2.667 2.667 0 012.667 0H10c.368 0 .667.298.667.667V2a.667.667 0 01-.667.667H2.667v18.666zM16.853 4.2l6.854 6.84c.185.189.29.442.293.707v.506a1 1 0 01-.293.707l-6.854 6.84a.666.666 0 01-.946 0l-.947-.933a.666.666 0 010-.947l4.6-4.587H6a.667.667 0 01-.667-.666v-1.334c0-.368.299-.666.667-.666h13.56l-4.6-4.587a.653.653 0 010-.933l.947-.947a.667.667 0 01.946 0z",
    clipRule: "evenodd"
  });
};

exports.SignOut = SignOut;